export const createFlyingBunAnimationConfig = (nthOption) => (flyingBunAnimating) => (setFlyingBunAnimating) => ({
  from: { x: flyingBunAnimating === nthOption ? 1 : 0 },
  to: { x: flyingBunAnimating === nthOption ? 0 : 1 },
  immediate: flyingBunAnimating !== nthOption,

  config: {
    mass: 2,
    friction: 5,
    tension: 5,
  },

  onRest: () => setFlyingBunAnimating(false),
});
